module.exports = __webpack_public_path__ + "static/img/GE.d31ed47e.svg";